import React, { useContext } from 'react'
import { Product } from '../../Models/Product'
import Flag from 'react-world-flags'
import "./ProductCard.css"
import { Button, Tag } from 'antd'
import { ShoppingCartOutlined } from '@ant-design/icons'
import { PromiseSesionContext } from '../../Machines/ErrorMachine'
import { Monitor } from '../../Models/Monitor'
import { addMonitor } from '../../Api/Monitor'

interface Props{
    producto:Product
    type: "soon" | "disponibles"
}

const ProductCard = ({producto, type}:Props) => {
    const {cart, sendCart} = useContext(PromiseSesionContext);
    const {error, sendError} = useContext(PromiseSesionContext);

    const addCart = ()=>{

      sendCart({type: "ADD", data:{producto:producto}})
      sendError({type: "ERROR", data:{message:`${producto.name} agregada al carrito`, type:"info"}})

    }
  const isCreatedWithinAWeek = (dateString: string): boolean=> {
  // 1. Convertir la cadena de fecha a un objeto Date
  const createdAt = new Date(dateString);

  // 2. Obtener la fecha y hora actual
  const now = new Date();

  // 3. Calcular la diferencia en milisegundos
  const diffInMilliseconds = now.getTime() - createdAt.getTime();

  // 4. Definir una semana en milisegundos
  const oneWeekInMilliseconds = 7 * 24 * 60 * 60 * 1000;

  // 5. Comparar la diferencia con una semana
  return diffInMilliseconds < oneWeekInMilliseconds;
  }
  
        const sendMonitor = async ()=>{
            try{let user:string= localStorage.getItem("user") || ""
  
            let monitor:Monitor={
                action:`Agrego al carrito: ${producto.name}`,
                user:user
            }
            await addMonitor(monitor)}
            catch(error){}
        }
        
  return (
    <div className='ProductCard-component'>
        <div className='ProductCard-info' style={{borderRadius: type==="soon" ? "35px 35px 35px 35px" : "35px 35px 0px 0px"}}>

        {/* <div className='ProductCard-TCG-alt'>
        <span>{producto.tcg==="pokemon" ? "Pokemon TCG" : producto.tcg==="one piece" ? "One Piece" : producto.tcg==="yugioh" ? "Yugioh" : producto.tcg==="lorcana" ? "Lorcana" : <></> }</span>
        </div> */}
        <div className='ProductCard-imagen'>
            <img src={producto.image} />

            {producto.discount &&
            <div className='ProductCard-discountNew ProductCard-discount-color'>
              Ahorra <strong style={{ color: '#D4AF37' }}>{producto.discount}%</strong>
            </div>
            }
            
            {(isCreatedWithinAWeek(producto.created_at) && type=="disponibles" ) &&
            <div className='ProductCard-new'>
              <span>Nuevo</span>
            </div>}

            {(producto.order==1 && type=="soon") &&
            <div className='ProductCard-new'>
              <span>Pronto</span>
            </div>}

            <div className='ProductCard-flag'>
              <span>{producto.language==="chino" ? <Flag height={20} code={ "CN"} style={{border:"1px solid #000" }} /> : producto.language==="ingles" ? <Flag height="20" code={ "US"} style={{border:"1px solid #000"}} /> : producto.language==="espanol" ? <Flag height="20" code={ "ES"} style={{border:"1px solid #000"}} /> : producto.language==="japones" ? <Flag height="20" code={ "JP"} style={{border:"1px solid #000"}} /> : <Flag height="20" code={ "JP"} style={{opacity:"0", border:"1px solid transparent"}} />  } </span>
            </div>
        </div>
        {/* <div className='productCard-w-divider'></div> */}

        <div className='ProductCard-Subheader'>
          <span className='productCard-textName'>{producto.name.slice(0,38)}</span> 
        {/* {(!producto.discount_price ) && <>
          {type==="disponibles" ? <div className='productCard-PriceList'> <span className='ProductCard-price'>${producto.price} <span className='ProductSection-pricesubtitle'>(BCV)</span></span>  <span> ${producto.cash_price}<span className='ProductSection-pricesubtitle'>(CASH)</span></span></div>
          : producto.price ? <span className='ProductCard-price'> ${producto.price} - ${producto.aprox_price} <span className='ProductSection-pricesubtitle'>(BCV)</span> </span>
          : <span className='ProductCard-price'>Por confirmar</span>}
          </>
        } */}
        {/* {type==="disponibles" && <span className='ProductCard-price'></span>} */}
        {(producto.discount_price && type=="disponibles") && <span className='ProductCard-price'> <div className='ProductCard-discountSection'> <span className='dash-price'>${producto.price}</span> <span className='ProductSection-newPrice'>${producto.discount_price} <span className='ProductSection-pricesubtitle'>(BCV)</span> </span></div></span>}
        
        {/* <span>{producto.language==="chino" ? <Flag height={20} code={ "CN"} style={{border:"1px solid #000" }} /> : producto.language==="ingles" ? <Flag height="20" code={ "US"} style={{border:"1px solid #000"}} /> : producto.language==="espanol" ? <Flag height="20" code={ "ES"} style={{border:"1px solid #000"}} /> : producto.language==="japones" ? <Flag height="20" code={ "JP"} style={{border:"1px solid #000"}} /> : <Flag height="20" code={ "JP"} style={{opacity:"0", border:"1px solid transparent"}} />  } </span> */}
        </div>

     
        {/* <div className='ProductCard-name'>
            <span>{producto.name.slice(0,38)}</span>
        </div> */}

          <div className='productoCard-newPrice-section'>
            <div className='productCard-newPrice-block'>
                {(producto.status=="disponible" && producto.price )? <span className='productCard-newPrice-textBCV'>${producto.price}</span>
                :<span className='productCard-newPrice-textBCV'>{producto.aprox_price ? ("$"+producto.aprox_price) : "¿?"}</span>}
                {(producto.status=="disponible" || producto.aprox_price || true) && <Tag color='#DBDBDB' className='tag-bcv'>TASA BCV </Tag>}
            </div>

            {(producto.status=="disponible" || producto.aprox_price || true ) && <><div className='productCard-newPrice-divider'></div>
            <div className='productCard-newPrice-block'>
                <span className='productCard-newPrice-textCash'>${producto.cash_price}</span>

                {/* <span className='productCard-newPrice-textCash'>${producto.cash_price}</span> */}
                <Tag color='#007d0098' className='tag-cash'>Divisas</Tag>
            </div>
            </>}

          </div>
        </div>

        
        {type==="disponibles" && <button className='ProductCard-Button' onClick={() => {sendMonitor();addCart()}}>Agregar <ShoppingCartOutlined /></button>}

        <div className='ProductCard-TCG'>
        <span>{producto.category==="figura" ? "Figura" :
               producto.tcg==="pokemon" ? "Pokemon TCG" : 
               producto.tcg==="one piece" ? "One Piece" : 
               producto.tcg==="yugioh" ? "Yugioh" : 
               producto.tcg==="lorcana" ? "Lorcana" 
               : "Otros" }</span>
        </div>
    </div>
  )
}

export default ProductCard